const theme = {
  primary: "#fdcc00",
  darkGray: "#505156",
  darkBlue: "#24262c",
  navy: "#064098",
  green: "#8dc538",
  red: "#fa4c39",
  lightYellow: "#fdf4cc",
  lightGray: "#f7f7f5",
  borderGray: "#cfcecd",
  borderGraySecondary: "#e2e2e3",
  borderGrayRecipe: "#717276"
};

export default theme;
